import React from 'react';
import { SvgIcon } from '@mui/material';

const SvgPriceReductions = (props) => (
  <SvgIcon {...props} title="PriceReductions">
    <svg
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#PriceReductions_svg__a)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M18.468.152C9.574 1.489 3.328 9.928 4.636 18.842c.234 1.594.667 2.157 1.659 2.157 1.176 0 1.69-.844 1.419-2.333C6.267 10.7 12.769 3.067 20.999 3.067c12.636 0 18.26 16.079 8.376 23.944-1.45 1.154-1.078 2.987.607 2.988 1.627.001 5.026-3.926 6.389-7.38C41.054 10.742 31.1-1.749 18.468.151ZM2.178 24.186c-.623.38-.892 1.39-.544 2.044.255.482 12.334 12.441 12.983 12.856.97.619 1.907.878 3.195.884l1.078.005 6.188-1.667c5.816-1.567 6.227-1.665 6.85-1.628 1.097.065 1.19.14 5.483 4.434l3.884 3.885H38.39c-2.735.001-2.924.012-3.212.187-.925.564-.925 2.062 0 2.626.476.29 10.166.29 10.643 0 .704-.43.678-.201.678-5.813 0-4.84-.007-5.026-.187-5.32-.563-.926-2.062-.926-2.626 0-.175.287-.186.476-.186 3.208v2.902l-4.102-4.084c-6.248-6.223-5.344-6.019-15.07-3.408-5.496 1.476-6.247 1.656-6.714 1.614-1.114-.101-.95.041-7.583-6.577-3.378-3.37-6.233-6.174-6.346-6.23-.339-.173-1.163-.127-1.507.082Z"
          fill="#017163"
        />
      </g>
      <path
        d="M20.29 8.228c2.46-.672 4.992 1.334 4.99 3.923 0 .855-.521 1.378-1.137 1.398-.612.02-1.177-.462-1.257-1.312-.088-.93-.681-1.474-1.322-1.596-.638-.121-1.36.168-1.735 1.002l-.13.29-.019 2.097-.016 1.897h1.315c.49 0 .88.006 1.188.03.303.023.55.065.74.15a.758.758 0 0 1 .421.433c.07.179.082.39.082.612 0 .221-.013.432-.082.612a.759.759 0 0 1-.42.432c-.19.085-.437.127-.738.15-.306.025-.695.03-1.184.031h-1.312l-.016 1.597c-.006.508-.016.983-.028 1.34a15.728 15.728 0 0 1-.02.446l.072.003c.325.014.958.016 2.172.016 1.224 0 1.874.001 2.24.017.181.008.308.02.406.042.11.025.178.061.241.101.376.24.549.664.549 1.065 0 .4-.173.826-.549 1.065a.415.415 0 0 1-.127.05 1.3 1.3 0 0 1-.114.02 4.962 4.962 0 0 1-.313.03c-.251.018-.59.033-.985.045-.791.024-1.82.036-2.847.036s-2.056-.012-2.847-.036a25.02 25.02 0 0 1-.985-.045 4.962 4.962 0 0 1-.314-.03 1.294 1.294 0 0 1-.114-.02.415.415 0 0 1-.126-.05 1.192 1.192 0 0 1-.523-1.355 1.348 1.348 0 0 1 1.147-.965c.191-.025.305-.055.381-.099.065-.036.118-.09.163-.205.05-.125.087-.313.111-.604a17 17 0 0 0 .04-1.147l.016-1.317h-.38c-.468 0-.854-.062-1.121-.27-.285-.224-.373-.563-.373-.955s.088-.73.372-.954c.267-.21.652-.271 1.12-.271h.378v-1.993c0-1.253.002-1.927.058-2.392l2.931-3.314Zm0 0c-1.099.3-2.078 1.112-2.552 2.123l2.551-2.123Z"
        fill="#017163"
        stroke="#017163"
        strokeWidth={0.5}
      />
      <defs>
        <clipPath id="PriceReductions_svg__a">
          <path fill="#fff" d="M0 0h48v48H0z" />
        </clipPath>
      </defs>
    </svg>
  </SvgIcon>
);

export default SvgPriceReductions;
